$(document).ready(function () {
  let swiper = null;
  let swiper2 = null;
  let observerActivated = false;
  let previousUrl = '';
  let debounceTimer;
  const mainProductManualExists = $("#MainProduct__manual").length > 0;
  let skipFirstLoad = mainProductManualExists;
 
  const $gallerySwiper = $(".gallerySwiper");
  const $mainSwiper = $(".mainSwiper");
  const $imageZoomButton = $(".ImageZoomButton");
  const $mainProductImages = $(".MainProduct__images");


  // Initialize Swiper for product images and gallery
  function initSwiper() {
    if ($gallerySwiper.length) {
      swiper = new Swiper(".gallerySwiper", {
        loop: true,
        spaceBetween: 30,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
      });
    }

    if ($mainSwiper.length) {
      swiper2 = new Swiper(".mainSwiper", {
        loop: true,
        spaceBetween: 0,
        thumbs: {
          swiper: swiper,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
      });

      swiper2.on("slideChange", function () {
        if ($imageZoomButton.hasClass("active")) {
          $(".zoomActive").removeClass("zoomActive");
          $imageZoomButton.removeClass("active");
        }
      });
    }
  }

  // Handle URL changes and update the slider for the correct variant
  function handleUrlChange() {
    if (skipFirstLoad) {
      skipFirstLoad = false;
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const variant = searchParams.get("variant");
    
    if (variant) {
      slideToVariant(variant, observerActivated ? 500 : 0);
      if (!observerActivated) {
        observer.observe(document, config);
        observerActivated = true;
      }
    } else {
      const preselectedColorVariant = $("input[type='radio'][name*='Farbe']:checked").attr("data-variant-id");
      if (preselectedColorVariant) {
        slideToVariant(preselectedColorVariant);
      }
      if (!observerActivated) {
        observer.observe(document, config);
        observerActivated = true;
      }
    }

    previousUrl = location.href;
  }

  // Slide to a specific variant
  function slideToVariant(variant, time = 0) {
    $mainSwiper.find(".swiper-slide").each(function () {
      const imgVariants = $(this).attr("data-variants");
      if (imgVariants && imgVariants.includes(variant)) {
        const swiperIndex = $(this).attr("data-swiper-slide-index");
        swiper2.slideToLoop(swiperIndex, time, false);
        if ($gallerySwiper.length) {
          swiper.slideToLoop(swiperIndex, time, false);
        }
        $(this).addClass("swiper-slide-active");
      }
    });
  }

  // Show product sliders
  function showProductSliders() {
   $mainProductImages.animate({ opacity: 1 }, 650);
  }

  // Zoom functionality for product images
  $imageZoomButton.click(function () {
    if ($mainSwiper.length) {
      $mainSwiper.find(".swiper-slide-active .FixedRatio").toggleClass("zoomActive");
    } else {
      $(".SingleImage").toggleClass('zoomActive');
    }
    $(this).toggleClass("active");
  });

  // Zoom image on hover
  $mainProductImages.on('mouseover', '.zoomActive', function () {
    const $img = $(this).children('.BackgroundMedia').find("img");
    $img.css('transform', 'scale(1.6)');

    $(this).on("mousemove", function (e) {
      $img.css('transform-origin', 
        ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + 
        ((e.pageY - $(this).offset().top) / $(this).height()) * 100 + '%'
      );
    });
  });

  // Reset zoom on mouse out
  $mainProductImages.on('mouseout', '.zoomActive', function () {
    $(this).children('.BackgroundMedia').find("img").css('transform', 'scale(1)');
    $imageZoomButton.removeClass("active");
    if ($mainSwiper.length) {
      $mainSwiper.find(".swiper-slide-active .FixedRatio").removeClass("zoomActive");
    } else {
      $(".SingleImage").removeClass('zoomActive');
    }
  });

  // Mutation observer to handle URL changes with debounce
  const observer = new MutationObserver(function () {
    if (location.href !== previousUrl) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(handleUrlChange, 300);
    }
  });

  const config = { subtree: true, childList: true };

  initSwiper();
  //handleUrlChange();

  if (mainProductManualExists) {
    const firstColorRadio = $("#MainProduct__manual input[type='radio'][name*='Farbe']").first();
    firstColorRadio.prop("checked", false);
    firstColorRadio.click();
    
    if (!observerActivated) {
      observer.observe(document, config);
      observerActivated = true;
    }
  }
  
  // Wait for the window load event to ensure all assets are fully loaded, then show sliders
   $(window).on('load', function() {
    showProductSliders();
    handleUrlChange();
     
    if (mainProductManualExists) {
     setTimeout(function() {
       $("product-info").css("display", "block");
     }, 1500);
    }
  });

  
});



